import { EmailAction, Message, Recipient } from "@/repository/models/message";
import { SendType } from "@/common/stores/nonpersistingStores/currentInteraction";

export interface EmailEditorProps {
	isSubjectEditingEnabled?: boolean;
	data: EmailData;
	onChange: (
		data: EmailData,
		isMainContentChanged: boolean,
		draftNeedsUpdate: boolean,
		callingMethod: string
	) => void;
	onSendClick: (sendType: SendType) => void;
	closeEditor: () => void;
	isOutboundConversationStart?: boolean;
	sessionId?: string;
	isSendDisabled?: boolean;
	isFirstEmailInConversation: boolean;
	onAttachmentDeleted?: () => void;
	draftParentMessageId?: string;
	emailAction?: EmailAction;
}

export interface AttachmentsViewProps {
	data: EmailData;
	isDragActive: boolean;
	onAttachmentRemove: (attachment: AttachmentData) => void;
	isRemoveAllowed: boolean;
}

export interface EmailSubjectInputProps {
	data: EmailData;
	onChange: (
		data: EmailData,
		isMainContentChanged: boolean,
		draftNeedsUpdate: boolean,
		callingMethod: string
	) => void;
	isReadOnlyMode: boolean;
	emailHasDraft: boolean;
	isFirstEmailInConversation: boolean;
}

export class EmailData {
	to: RecipientData[] = [];
	cc: RecipientData[] = [];
	bcc: RecipientData[] = [];
	subject: string = "";
	body: string = "";
	attachments: AttachmentData[] = [];
	type: EmailAction = EmailAction.Reply;
	refMessage?: Message;
	hasAiContent: boolean = false;
}

export interface AttachmentData {
	id?: string;
	file: File;
	contentId?: string;
	uploadStatus: UploadStatus;
}

export enum UploadStatus {
	None = 0,
	InProgress = 1,
	Completed = 2,
}

export interface RecipientData extends Recipient {
	isValid: boolean;
}

export const EmailAttachmentMaxSizeBytes = 3 * 1024 * 1024;
